module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conjunto-datos"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "body"
  }, [(_vm.model) ? _c('strong', [_vm._v(_vm._s(_vm.formattedValue))]) : _c('strong', {
    staticClass: "danger"
  }, [_vm._v(_vm._s(_vm.dangerMessage))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76c3cd1c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Datos_Conjuntos.vue
// module id = 909
// module chunks = 0